import { CellContext, RowData } from '@tanstack/react-table';
import { useUser } from '../../../hooks/use-user';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import React from 'react';
import { CourseDataEntry } from './CourseAgenda/CourseAgendaOverview';
import moment from '../../../moment';
import { findExistingReservation, getCalculatedReservationAmounts } from '../../../utils/training';

type Props = CellContext<CourseDataEntry, unknown> & {
	onEnrollClick: (row: RowData) => void;
	onReserveClick: (row: RowData) => void;
};
export const ActionCell = (cellInfo: Props) => {
	const { isSchoolAdmin, isSchoolSuperUser } = useUser();
	const { t } = useTranslation();
	if (cellInfo.row.depth > 0) {
		return null;
	}

	const {
		row: { original },
	} = cellInfo;
	return !(isSchoolAdmin || isSchoolSuperUser) ? (
		<div className="d-flex flex-row-reverse">
			<Button
				className="ms-1"
				variant="outline-primary"
				type="button"
				size="sm"
				onClick={(e) => {
					e.stopPropagation();
					cellInfo.onReserveClick(original);
				}}>
				{t('trainings.reserve')}
			</Button>
			{!original.composite && (
				<Button
					variant="outline-primary"
					type="button"
					size="sm"
					onClick={(e) => {
						e.stopPropagation();
						cellInfo.onEnrollClick(original);
					}}>
					{t('trainings.enroll')}
				</Button>
			)}
		</div>
	) : null;
};

export const DateCell = (cellInfo: CellContext<CourseDataEntry, unknown>) => {
	const { row } = cellInfo;
	return (
		<div
			className={`${row.getIsExpanded() && row.depth === 0 ? 'text-primary' : 'text-primary-color'}`}>
			{row.depth > 0 ? row.original.start : moment(row.original.start).format('L')}
		</div>
	);
};

export const ExpanderCell = ({ row }: CellContext<CourseDataEntry, unknown>) => {
	if (row.getCanExpand()) {
		const chevronStyle = row.getIsExpanded()
			? 'glyphicons-chevron-down text-primary'
			: 'glyphicons-chevron-up text-secondary';
		return (
			<div
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					row.getToggleExpandedHandler()();
				}}
				style={{ cursor: 'pointer' }}>
				<span className={`glyphicons ${chevronStyle}`} />
			</div>
		);
	}

	return null;
};

export const ReservationCell = ({ row }: CellContext<CourseDataEntry, unknown>) => {
	const { activeCompany } = useUser();
	const trainingReservations = row.original.trainingReservations;
	const existingReservation =
		findExistingReservation(trainingReservations || [], activeCompany.id) || {};

	const { amountPlanned, amountReserved } = getCalculatedReservationAmounts(
		existingReservation,
		activeCompany.id,
	);
	return amountReserved ? (
		<div>
			{amountPlanned} / {amountReserved}
		</div>
	) : null;
};
